module.exports = __webpack_public_path__ + "static/media/history-bagpipe.5c64b1e0.mp4";